export const otaConnectWizard = {
  google: {
    lead: "First we check your property details are complete: Google has no extranet and only shows what we send it.",
    goConnect: "Continue in Channex",
    nextIsChannex: "The last step — choosing which rooms and rates Google sees — happens in the Channex screen, which opens next.",
    typeLabel: "What kind of place is it?",
    hotel: "Hotel",
    hotelHint: "With several rooms",
    vr: "Vacation rental",
    vrHint: "A whole house or apartment",
    checking: "Checking the property details…",
    ready: "All set: Google can publish it.",
    missing: "1 thing missing before connecting | {count} things missing before connecting",
    canFix: "We already have some of that saved and can upload it for you.",
    prepare: "Prepare the listing",
    prepareFailed: "Could not prepare the listing.",
    checkFailed: "Could not check the listing.",
    cancelLabel: "Cancellation policy",
    cancelFree: "Free cancellation",
    cancelNon: "Non-refundable",
    bedrooms: "Bedrooms",
    beds: "Beds",
    bathrooms: "Bathrooms",
  },
  common: {
    close: "Close",
  },
  intro: {
    imageAlt: "Before connecting Booking, keep this in mind",
    continue: "Got it, continue",
  },
  header: {
    edit: "Edit",
    connect: "Connect",
    guidedStep: "Guided setup · step {current} of {total}",
  },
  steps: {
    connection: "Connection",
    rooms: "Rooms",
    rates: "Rates",
    review: "Review",
    done: "Done",
  },
  fields: {
    hotel_id: { label: "Hotel ID", hint: "You'll find it in your OTA extranet, top right." },
    hotel_code: { label: "Hotel code", hint: "Your property's identifier on the OTA." },
    property_id: { label: "Property ID", hint: "" },
    listing_id: { label: "Listing ID", hint: "" },
    property_code: { label: "Property code", hint: "" },
    username: { label: "Username", hint: "Your login username for the OTA extranet." },
    user: { label: "Username", hint: "Your login username for the OTA extranet." },
    password: { label: "Password", hint: "Your OTA extranet password." },
    api_key: { label: "API key", hint: "The OTA provides it to you." },
    agent_id: { label: "Agent ID", hint: "" },
  },
  step0: {
    lead: "Paste your property's identifier on the channel. We'll verify it instantly.",
    loadingChannel: "Loading channel requirements…",
    notAvailable: "This channel isn't available yet via guided API.",
    oauthText: "{name} connects to your account through secure sign-in. When you click, we open {name} in another tab so you can authorize; once you return, the connection appears in your channels.",
    oauthConnect: "Connect with {name}",
    oauthOpened: "We opened {name} in another tab. Authorize there and the connection will appear in your channels.",
    currencyLabel: "Currency",
    currencyTooltip: "The channel sets it for your property. It fills in automatically when you verify the connection; it can't be edited.",
    currencyPlaceholder: "Fills in on verify",
    currencyDetected: "Detected automatically",
    currencyVerifyToDetect: "Verify the connection to detect it",
    verified: "Verified",
    testConnection: "Test connection",
    testOk: "Connection verified. Continue to match rooms and rates.",
    testFailedDefault: "We couldn't verify the connection. Check the identifier.",
  },
  step1: {
    leadAirbnb: "Match each Airbnb listing with one of your units.",
    leadOther: "Match each {channel} room with a unit from your listing.",
    listingChip: "Listing: {name}",
    noLimitChip: "No limit on accounts or properties",
    loadingRooms: "Loading channel rooms…",
    noRooms: "No rooms found to map.",
    dupUnitWarning: "«{unit}» is assigned to more than one {channel} room. Each channel room must go to a different room of yours: if saved this way, {channel} would sell them all at the same price. Fix it below before continuing.",
    searchPlaceholder: "Search…",
    noRoomMatch: "No room matches «{query}».",
    copied: "Copied",
    copyId: "Copy ID: {id}",
    rateCountMeta: "{channel} · {count} rate(s)",
    edit: "Edit",
    disconnect: "Disconnect",
    unitSearchPlaceholder: "Search your unit or listing…",
    noMatch: "No matches",
    cancel: "Cancel",
  },
  step2: {
    lead: "Each room's main rate fills in automatically from your {channel} rate. If a room has several rates, set how much more (or less) % you'll charge on each.",
    crossedFixed: "One rate was matched with another room, which would make {channel} sell at the wrong price. Each room's own rate has been restored: review them before continuing. | {count} rates were matched with another room, which would make {channel} sell at the wrong price. Each room's own rate has been restored: review them before continuing.",
    noRates: "No rates found to map.",
    yourPct: "Your % for this room",
    auto: "Automatic",
    changePct: "Change %",
    multiRateAlert: "This room has several rates. Set what percentage more (or less) you'll charge your guests on each one if they book through {channel}.",
    minStayOnApply: "It is saved when you press “Apply”.",
    minStayMissing: "No own minimum stay: {channel} sells it with the main rate's minimum",
    setMinStay: "Set minimum stay",
    nights: "{n} night | {n} nights",
    minNights: "min. {n} night | min. {n} nights",
    minInherited: "main rate's min.",
    ownPlanSummary: "own price and minimum",
    minStayNotDerived: "The minimum stay of {nights} was not set: “{rate}” is a main rate and uses its own minimum stay. For {channel} to require {nights} on this rate, apply a % instead of choosing it.",
  },
  step3: {
    lead: "This is what we'll connect on {channel}. Review it and click Connect.",
    channelCurrency: "Channel currency:",
    chargesNote: "Check-in/out and charges (cleaning, etc.) are taken from your property settings.",
  },
  done: {
    titleConnected: "{name} connected!",
    titleUpdated: "{name} updated!",
    subActive: "The channel is active: we're already syncing prices and availability.",
    subPaused: "The channel is connected but paused. Activate it to start syncing prices and availability.",
    subUpdated: "The channel mapping was updated successfully.",
    notificationSent: "Notification sent",
    syncing: "Syncing…",
    paused: "Paused",
    activateTitle: "Activate channel",
    activateDesc: "Starts sending prices and availability to {channel}.",
    activateBtn: "Activate channel",
    activated: "Activated",
    loadReservationsTitle: "Import future bookings",
    loadReservationsDesc: "Brings the bookings you already have on {channel} into WACheckin.",
    imported: "Imported",
    extract: "Import",
  },
  rates: {
    mainRate: "Main rate",
    standardRate: "Standard Rate",
  },
  rooms: {
    listingFallback: "Listing {id}",
    unitFallback: "unit",
  },
  buttons: {
    back: "Back",
    saveChanges: "Save changes",
    connect: "Connect",
    finish: "Finish",
    continue: "Continue",
  },
  errors: {
    dupUnit: "The unit «{unit}» is assigned to more than one {channel} room. Each room must go to a different unit.",
    crossedBlocked: "There is one rate matched with another room ({list}). Go back to the rates step and pick each room's own rate: if saved this way, {channel} would sell at the wrong price. | There are {count} rates matched with another room ({list}). Go back to the rates step and pick each room's own rate: if saved this way, {channel} would sell at the wrong price.",
    dupRate: "The rate «{rate}» is matched with more than one {channel} room ({rooms}). Each room must carry its own rate: if saved this way, they would sell at the same price.",
    roomJoiner: " and ",
    dupRateFallback: "a rate",
    dupUnitFallback: "this unit",
    needRate: "Match at least one rate before connecting.",
    updateFailed: "Couldn't update the connection.",
    createFailed: "Couldn't create the connection.",
    unmapFailed: "Couldn't disconnect the listing.",
    needAirbnbMap: "Match at least one listing with a unit.",
    unitNoChannexRate: "The unit \"{unit}\" has no rate with a Channex id.",
    airbnbSaveFailed: "Couldn't save the Airbnb mappings.",
    actionFailed: "Couldn't run the action.",
    oauthLinkFailed: "Couldn't generate the connection link.",
    testFailed: "Error testing the connection.",
    testNoVerify: "This channel doesn't require prior verification.",
    rateCreateFailedNeedStandard: "Couldn't create the rate. Check that the unit has a Standard Rate.",
    rateCreateFailed: "Couldn't create the rate.",
    minStaySaveFailed: "“{rate}” was chosen, but its minimum stay of {nights} couldn't be saved: it keeps the one it had.",
  },
};
